<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-user-alt"></i> Associado</h3>
      </div>
    </div>
    <associateRegistrationAdd
      v-if="showAdd"
      ref="associateRegistrationAdd"
      v-on:Back="onBack"
    />
    <associateRegistrationList
      v-else
      ref="associateRegistrationList"
      v-on:New="onNew"
      v-on:Edit="onEdit"
    />
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import associateRegistrationAdd from './components/add/AssociateRegistrationAdd.vue'
import associateRegistrationList from './components/list/AssociateRegistrationList.vue'

export default {
  name: 'AssociateRegistration',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    associateRegistrationAdd,
    associateRegistrationList
  },
  mounted () {},
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  },
  methods: {
    onLoad () {},
    onNew () {
      this.showAdd = true
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.associateRegistrationAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/Associate/AssociateRegistration.vue